import type { Decision, DecisionStatus } from "../types";
import { parseAssumptions } from "./parse-assumptions-v3";
import { asString, asStringArray, parseBoldEntriesV3 } from "./parse-bullets-v3";

// ## Decisions
// v0.3 decisions are bullet-list entries (no H3 headings). Each has a slug
// in `**bold**`, status / date / title / context / options_considered /
// chosen / why fields; superseded decisions reference their replacement via
// `superseded_by: <slug>`.

const STATUS_VALUES: ReadonlySet<DecisionStatus> = new Set([
  "proposed",
  "accepted",
  "superseded",
  "deprecated",
  "accepted-with-known-tradeoff",
]);

export function parseDecisionsV3(body: string): Decision[] {
  const entries = parseBoldEntriesV3(body, "Decisions");
  return entries.map((entry) => {
    const p = entry.properties;
    const scope = `Decisions.${entry.id}`;
    const rawStatus = (asString(p.status) ?? "proposed").toLowerCase();
    const status: DecisionStatus = STATUS_VALUES.has(rawStatus as DecisionStatus)
      ? (rawStatus as DecisionStatus)
      : "proposed";
    const options_considered = asStringArray(p.options_considered);
    const assumptions = parseAssumptions(p.assumptions, { scope, strict: true });
    return {
      id: entry.id,
      label: asString(p.title) ?? asString(p.label) ?? entry.id,
      status,
      title: asString(p.title),
      options_considered: options_considered.length > 0 ? options_considered : undefined,
      chosen: asString(p.chosen),
      superseded_by: asString(p.superseded_by),
      context: asString(p.context),
      why: asString(p.why),
      date: asString(p.date),
      applies_to: asStringArray(p.applies_to),
      assumptions: assumptions.length > 0 ? assumptions : undefined,
    };
  });
}
